import {Nullable} from '../../app/TypeHelpers'
import {ImageLocation} from './FacilityDetails'
import {FACILITY_CATEGORY} from '../../CodeMaster'

export default class FacilityInfoDetails {
    category: FACILITY_CATEGORY
    facilityName: string
    images: ImageLocation[]
    facilityIntroductory: Nullable<string>

    constructor(
        category: FACILITY_CATEGORY,
        facilityName: string,
        images: ImageLocation[],
        facilityIntroductory: string | null,
    ) {
        this.category = category
        this.facilityName = facilityName
        this.images = images
        this.facilityIntroductory = facilityIntroductory
    }

    static from(json: any): FacilityInfoDetails {
        return new FacilityInfoDetails(
            FACILITY_CATEGORY.codeToEnumConstants(json.categoryId)!,
            json.facilityName,
            json.images,
            json.facilityIntroductory,
        )
    }
}
